import {JSX, JSXElement, splitProps} from "solid-js";
import css from "./section.module.css";

interface SectionProps extends JSX.HTMLAttributes<HTMLElement> {
    children: JSXElement | JSXElement[];
}

export default function Section(props: SectionProps) {
    const [local, rest] = splitProps(props, ["class", "children"]);

    return (
        <section
            class={`${css.section} ${local.class || ""}`.trim()}
            {...rest}
        >
            {local.children}
        </section>
    );
}